module.exports = __webpack_public_path__ + "img/dealing_real_estate.1ced13ea.jpg";